<fullscreen-page>
  <navigation-column class="dq-navigation">
    <div class="p-2 h-100 d-flex flex-column">
      <div class="dx-field dq-method-field" style="margin: 0 0 5px;">
        <div class="dx-field-label">
          <div class="dq-title">
            <np-help-button>
              <np-help-option
                text="Wiki"
                icon="images/Wiki.svg"
                link="https://knowledge.nextpim.de/anlage-einer-eigenen-datenvalidierung">
              </np-help-option>
            </np-help-button>
    
            <span class="dq-title-text">{{ 'Datenqualität-Set' | translate }}</span>
          </div>
        </div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="validationMethods"
                         [(value)]="selectedValidationMethod"
                         [displayExpr]="getValidationMethodDisplayText"
                         itemTemplate="methodItem"
                         (onValueChanged)="onValidationMethodChanged($event)">
            <dxo-select-box-drop-down-options [width]="400"></dxo-select-box-drop-down-options>
            <div *dxTemplate="let method of 'methodItem'" class="dq-method-item">
              <span class="dq-method-item-name">{{ method.name }}</span>
              <span *ngFor="let badge of validationMethodBadges(method)" class="dq-badge">{{ badge }}</span>
            </div>
          </dx-select-box>
        </div>
        <div class="d-flex align-items-center flex-shrink-0">
          <dx-button stylingMode="text" type="default" icon="plus" hint="{{ 'Datenqualität-Set erstellen' | translate }}"
                     (onClick)="showCreateValidationMethodPopup()"></dx-button>
          <dx-drop-down-button *ngIf="selectedValidationMethod != undefined"
                               icon="overflow"
                               stylingMode="text"
                               [showArrowIcon]="false"
                               hint="{{ 'Aktionen' | translate }}"
                               [items]="methodMenuItems"
                               displayExpr="text"
                               keyExpr="action"
                               [dropDownOptions]="{ width: 240 }"
                               (onItemClick)="onMethodMenuItemClick($event)"></dx-drop-down-button>
        </div>
      </div>
      <div *ngIf="selectedValidationMethod != undefined && !isReadOnlyForUser(selectedValidationMethod)" class="my-1">
        <dx-button stylingMode="text" type="default" icon="plus" text="{{ 'Neue Gruppe' | translate }}" (onClick)="createValidationGroup()"></dx-button>
      </div>
      <dx-tree-view [dataSource]="validationGroups"
                    itemsExpr="rules"
                    [noDataText]="noDataText"
                    [selectionMode]="'single'"
                    [selectByClick]="false"
                    (onItemClick)="onTreeItemClick($event)"
                    (onSelectionChanged)="onValidationItemSelection($event)">
        <div *dxTemplate="let item of 'item'" style="width: 100%;">
          <div class="d-flex flex-row align-items-center justify-content-between dq-tree-row">
            <div *ngIf="itemIsValidationGroup(item)" class="dq-tree-item-text flex-fill text-truncate fw-semibold" [title]="item.name">
              <span class="dq-group-dot" [style.background-color]="item.backgroundColor"></span>{{ item.name }}
              <span class="fw-normal text-secondary">({{ item.rules?.length ?? 0 }})</span>
            </div>
            <div *ngIf="!itemIsValidationGroup(item)" class="dq-tree-item-text flex-fill text-truncate" [title]="item.printName">
              <i *ngIf="item.isConditional" class="dx-icon dx-icon-filter dq-condition-icon" [title]="'(Bedingung)' | translate"></i>{{ item.printName }}
            </div>
            <div class="ml-auto text-nowrap dq-tree-actions">
              <dx-button *ngIf="itemIsValidationGroup(item) && !isReadOnlyForUser(selectedValidationMethod)"
                         stylingMode="text" type="default" icon="plus" hint="{{ 'Neue Regel' | translate }}"
                         (onClick)="createValidationRule(item)"></dx-button>
              <dx-button *ngIf="!isReadOnlyForUser(selectedValidationMethod)"
                         stylingMode="text" type="default" icon="copy" hint="{{ 'Kopieren' | translate }}"
                         (onClick)="duplicateValidationItem(item)"></dx-button>
              <dx-button *ngIf="!isReadOnlyForUser(selectedValidationMethod)"
                         stylingMode="text" type="default" icon="trash" hint="{{ 'Löschen' | translate }}"
                         (onClick)="deleteValidationItem(item)"></dx-button>
            </div>
          </div>
        </div>
      </dx-tree-view>
    </div>
  </navigation-column>
  <content-column helpSwitch="true" look="light">    
      <div slot="content" class="p-2 flex-fill overflow-hidden">
        <div *ngIf="selectedValidationMethod == undefined" class="dq-empty-state">
          <i class="dx-icon dx-icon-info"></i>
          <span>{{ 'Links ein Datenqualität-Set auswählen oder über + anlegen.' | translate }}</span>
        </div>
        <div *ngIf="selectedValidationItem == undefined && selectedValidationMethod != undefined"
             class="p-2 overflow-hidden h-100 dq-detail" style="display: grid; grid-template-rows: auto minmax(0, 1fr);">
          <div>
            <div class="dq-detail-header d-flex align-items-center flex-wrap gap-2">
              <h4 class="m-0">{{ 'Datenqualität-Set' | translate }} · {{ selectedValidationMethod.name }}</h4>
              <ng-container *ngTemplateOutlet="saveState"></ng-container>
              <span *ngFor="let badge of validationMethodBadges(selectedValidationMethod)" class="dq-badge">{{ badge }}</span>
            </div>
            <ng-container *ngTemplateOutlet="readOnlyInfo"></ng-container>
          </div>
          <dx-scroll-view [useNative]="false" showScrollbar="always">
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationMethod.name"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div *ngIf="isAdminUser() && !selectedValidationMethod.isShared && selectedValidationMethod.createdByCustomerId" class="dx-field">
              <div id="isGlobal" class="dx-field-label">{{ 'Global' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#isGlobal" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'isGlobalTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-switch [(value)]="selectedValidationMethod.isGlobal"
                           [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                           (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-switch>
              </div>
            </div>
            <div *ngIf="isAdminUser() && selectedValidationMethod.isGlobal" class="dx-field">
              <div id="isVisible" class="dx-field-label">{{ 'Sichtbar' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#isVisible" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'isVisibleTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-switch [(value)]="selectedValidationMethod.isVisible"
                           [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                           (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-switch>
              </div>
            </div>
            <div *ngIf="!selectedValidationMethod.isGlobal" class="dx-field">
              <div id="isShared" class="dx-field-label">{{ 'Teilbar' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#isShared" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'isSharedTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-switch [(value)]="selectedValidationMethod.isShared"
                           [readOnly]="isReadOnlyForUser(selectedValidationMethod) || isSharedIsReadOnly(selectedValidationMethod)"
                           (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-switch>
              </div>
            </div>
            <div *ngIf="selectedValidationMethod.isShared && isAdminUser()" class="dx-field">
              <div id="sharedToCustomers" class="dx-field-label">{{ 'Zugeteilte Kunden' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#sharedToCustomers" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'sharedToCustomerTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-tag-box [dataSource]="sharedToCustomersDataSource"
                            [(value)]="selectedValidationMethod.sharedToCustomers"
                            displayExpr="name"
                            valueExpr="id"
                            [searchEnabled]="true"
                            [showSelectionControls]="true"
                            (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-tag-box>
              </div>
            </div>
          </dx-scroll-view>
        </div>
        <div *ngIf="selectedValidationItem != undefined && itemIsValidationGroup(selectedValidationItem)"
             class="p-2 overflow-hidden h-100 dq-detail" style="display: grid; grid-template-rows: auto minmax(0, 1fr);">
          <div>
            <div class="dq-breadcrumb text-secondary">{{ selectedValidationMethod.name }}</div>
            <div class="dq-detail-header d-flex align-items-center flex-wrap gap-2">
              <h4 class="m-0">{{ 'Gruppe' | translate }} · {{ selectedValidationItem.name }}</h4>
              <ng-container *ngTemplateOutlet="saveState"></ng-container>
            </div>
            <ng-container *ngTemplateOutlet="readOnlyInfo"></ng-container>
          </div>
          <dx-scroll-view [useNative]="false" showScrollbar="always">
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.name"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="groupOrder" class="dx-field-label">{{ 'Reihenfolge' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#groupOrder" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'GroupOrderTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.order"
                               format="0#"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="groupBackgroundColor" class="dx-field-label">{{ 'Hintergrundfarbe' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#groupBackgroundColor" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'GroupBackgroundColorTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-color-box [(value)]="selectedValidationItem.backgroundColor"
                              applyButtonText="{{ 'Bestätigen' | translate }}"
                              cancelButtonText="{{ 'Abbrechen' | translate }}"
                              [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                              (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-color-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Vorschau' | translate }}</div>
              <div class="dx-field-value">
                <span class="dq-status-preview" [style.background-color]="selectedValidationItem.backgroundColor">
                  {{ selectedValidationItem.stateText }}
                </span>
              </div>
            </div>
            <div class="dx-field">
              <div id="groupInvalidStateText" class="dx-field-label">{{ 'Status-Text (nicht erfüllt)' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#groupInvalidStateText" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'GroupInvalidStateTextTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.stateText"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="groupValidStateText" class="dx-field-label">{{ 'Status-Text (erfüllt)' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#groupValidStateText" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'GroupValidStateTextTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.validStateText"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="groupIgnoreForReport" class="dx-field-label">{{ 'Für Reports ignorieren' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#groupIgnoreForReport" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'GroupIgnoreForReportTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-switch [(value)]="selectedValidationItem.ignoreForReport"
                           [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                           (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-switch>
              </div>
            </div>
          </dx-scroll-view>
        </div>
        <div *ngIf="selectedValidationItem != undefined && !itemIsValidationGroup(selectedValidationItem)"
             class="p-2 overflow-hidden h-100 dq-detail" style="display: grid; grid-template-rows: auto minmax(0, 1fr);">
          <div>
            <div class="dq-breadcrumb text-secondary">{{ selectedValidationMethod.name }} › {{ groupNameOf(selectedValidationItem) }}</div>
            <div class="dq-detail-header d-flex align-items-center flex-wrap gap-2">
              <h4 class="m-0">{{ 'Regel' | translate }} · {{ selectedValidationItem.printName }}</h4>
              <ng-container *ngTemplateOutlet="saveState"></ng-container>
            </div>
            <ng-container *ngTemplateOutlet="readOnlyInfo"></ng-container>
          </div>
          <dx-scroll-view [useNative]="false" showScrollbar="always">
            <div class="dx-fieldset-header">{{ 'Allgemein' | translate }}</div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.printName"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="ruleOrder" class="dx-field-label">{{ 'Reihenfolge' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#ruleOrder" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleOrderTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.order"
                               format="0#"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="RuleValidationTarget" class="dx-field-label">{{ 'Anwenden auf' | translate }}</div>
              <div class="dx-field-value">
                <dx-select-box [dataSource]="validationTargetOptions"
                               [(value)]="selectedValidationItem.validationTarget"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               valueExpr="value"
                               displayExpr="translated"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-select-box>
              </div>
            </div>
            <div class="dx-fieldset-header mt-4">{{ 'Geprüftes Feld' | translate }}</div>
            <div class="dx-field">
              <div id="RuleFieldGroup" class="dx-field-label">{{ 'Feld-Gruppe' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleFieldGroup" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleFieldGroupTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-select-box [dataSource]="fieldGroups"
                               [(value)]="selectedValidationItem.field.fieldGroup"
                               (onSelectionChanged)="onFieldGroupChanged($event)"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               valueExpr="value"
                               displayExpr="translated"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-select-box>
              </div>
            </div>
            <div *ngIf="showRuleFieldName(selectedValidationItem)" class="dx-field">
              <div id="RuleFieldName" class="dx-field-label">{{ 'Feld-Name' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleFieldName" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleFieldNameTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-select-box [dataSource]="fieldNamesInGroup"
                               [(value)]="selectedValidationItem.field.fieldName"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               valueExpr="value"
                               displayExpr="translated"
                               (onValueChanged)="changeFieldNameAndSaveValidationMethod(selectedValidationMethod, $event)">
                </dx-select-box>
              </div>
            </div>
            <div class="dx-fieldset-header mt-4" *ngIf="selectedItemFieldFilled()">{{ 'Prüfung' | translate }}</div>
            <div *ngIf="showRuleMandatoryField(selectedValidationItem)" class="dx-field">
              <div id="RuleMandatoryField" class="dx-field-label">{{ 'Pflichtfeld' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleMandatoryField" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleMandatoryFieldTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-switch [(value)]="selectedValidationItem.isRequired"
                           [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                           (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-switch>
              </div>
            </div>
            <div *ngIf="showRuleMinListCount(selectedValidationItem)" class="dx-field">
              <div id="RuleMinListCount" class="dx-field-label">{{ 'Minimale Anzahl' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleMinListCount" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleMinListCountTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.minCount"
                               placeholder="–"
                               format="#"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="showRuleMinLength(selectedValidationItem)" class="dx-field">
              <div id="RuleMinLength" class="dx-field-label">{{ 'Minimale Länge' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleMinLength" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleMinLengthTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.minLength"
                               placeholder="–"
                               format="#"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="selectedItemFieldIsPicture()" class="dx-field">
              <div id="RuleMinWidth" class="dx-field-label">{{ 'Minimale Breite' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleMinWidth" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleMinWidthTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.minWidth"
                               placeholder="–"
                               format="#"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="selectedItemFieldIsPicture()" class="dx-field">
              <div id="RuleMinHeight" class="dx-field-label">{{ 'Minimale Höhe' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleMinHeight" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleMinHeightTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.minHeight"
                               placeholder="–"
                               format="#"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="showRulePattern(selectedValidationItem)" class="dx-field">
              <div id="RulePattern" class="dx-field-label">{{ 'Muster (Regex)' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RulePattern" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RulePatternTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.pattern"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div class="dx-fieldset-header mt-4" *ngIf="selectedItemFieldFilled() && !selectedValidationItem.isConditional">{{ 'Bewertung' | translate }}</div>
            <div *ngIf="showRuleWeight(selectedValidationItem)" class="dx-field">
              <div id="RuleWeight" class="dx-field-label">{{ 'Punkte (Gewichtung)' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleWeight" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleWeightTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.points"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="showRuleWeightForElement(selectedValidationItem)" class="dx-field">
              <div id="RuleWeightForElement" class="dx-field-label">{{ 'Punkte pro Element (Gewichtung)' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleWeightForElement" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleWeightForElementTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.pointsPerCount"
                               placeholder="–"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="showRuleWeightMax(selectedValidationItem)" class="dx-field">
              <div id="RuleWeightMax" class="dx-field-label">{{ 'Maximale Punkte' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleWeightMax" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleWeightMaxTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-number-box [(value)]="selectedValidationItem.maxPoints"
                               placeholder="–"
                               [showSpinButtons]="true"
                               [showClearButton]="true"
                               [min]="0"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-number-box>
              </div>
            </div>
            <div *ngIf="selectedItemFieldFilled() && !selectedValidationItem.isConditional" class="dx-field">
              <div id="RuleArea" class="dx-field-label">{{ 'Bereich' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleArea" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleAreaTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-select-box [dataSource]="dataQualityAreas"
                               [(value)]="selectedValidationItem.area"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-select-box>
              </div>
            </div>
            <div class="dx-fieldset-header mt-4">{{ 'Meldungen' | translate }}</div>
            <div class="dx-field">
              <div id="RuleInvalidStateText" class="dx-field-label">{{ 'Status-Text (nicht erfüllt)' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleInvalidStateText" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleInvalidStateTextTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.stateText"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div *ngIf="selectedItemFieldFilled()" class="dx-field">
              <div id="RuleErrorText" class="dx-field-label">{{ 'Fehlertext' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
              <dx-tooltip target="#RuleErrorText" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleErrorTextTooltip' | translate }}</div>
              </dx-tooltip>
              <div class="dx-field-value">
                <dx-text-box [(value)]="selectedValidationItem.displayMessage"
                             [showClearButton]="true"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                </dx-text-box>
              </div>
            </div>
            <div *ngIf="selectedItemFieldFilled()" class="dq-filter-section mt-4">
              <div class="dx-fieldset-header">{{ 'Filter und Bedingungen' | translate }}</div>
              <div *ngIf="showFeatureSystemNameFilter()" class="dx-field">
                <div id="FeatureSystemNameFilter" class="dx-field-label">{{ 'Featuresystem-Name' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#FeatureSystemNameFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'FeatureSystemNameFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-autocomplete [(value)]="selectedValidationItem.featureSystemNameFilter"
                                   [dataSource]="featureSystemNames"
                                   [minSearchLength]="0"
                                   [showDropDownButton]="true"
                                   valueChangeEvent="change"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-autocomplete>
                </div>
              </div>
              <div *ngIf="showFeatureNameFilter()" class="dx-field">
                <div id="FeatureNameFilter" class="dx-field-label">{{ 'Feature-Name' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#FeatureNameFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'FeatureNameFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="selectedValidationItem.featureNameFilter"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-text-box>
                </div>
              </div>
              <div *ngIf="showMimeTypeFilter()" class="dx-field">
                <div id="MimeTypeFilter" class="dx-field-label">{{ 'Mime-Typ' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#MimeTypeFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'MimeTypeFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-autocomplete [(value)]="selectedValidationItem.mimeTypeFilter"
                                   [dataSource]="mimeTypes"
                                   [minSearchLength]="0"
                                   [showDropDownButton]="true"
                                   valueChangeEvent="change"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-autocomplete>
                </div>
              </div>
              <div *ngIf="showMimePurposeFilter()" class="dx-field">
                <div id="MimePurposeFilter" class="dx-field-label">{{ 'Mime-Verwendung' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#MimePurposeFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'MimePurposeFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-autocomplete [(value)]="selectedValidationItem.mimePurposeFilter"
                                   [dataSource]="mimePurposes"
                                   [minSearchLength]="0"
                                   [showDropDownButton]="true"
                                   valueChangeEvent="change"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-autocomplete>
                </div>
              </div>
              <div *ngIf="showMimeDescriptionFilter()" class="dx-field">
                <div id="MimeDescriptionFilter" class="dx-field-label">{{ 'Mime-Description' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#MimeDescriptionFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'MimeDescriptionFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="selectedValidationItem.mimeDescriptionFilter"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-text-box>
                </div>
              </div>
              <div *ngIf="showReferenceTypeFilter()" class="dx-field">
                <div id="ReferenceTypeFilter" class="dx-field-label">{{ 'Referenz-Typ' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#ReferenceTypeFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'ReferenceTypeFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="selectedValidationItem.referenceTypeFilter"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-text-box>
                </div>
              </div>
              <div *ngIf="showUdxGroupFilter()" class="dx-field">
                <div id="UdxGroupFilter" class="dx-field-label">{{ 'Udx-Gruppe' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#UdxGroupFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'UdxGroupFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="selectedValidationItem.udxGroupFilter"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-text-box>
                </div>
              </div>
              <div *ngIf="showSupplierNameFilter()" class="dx-field">
                <div id="SupplierNameFilter" class="dx-field-label">{{ 'Supplier-Name' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#SupplierNameFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'SupplierNameFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="selectedValidationItem.supplierNameFilter"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-text-box>
                </div>
              </div>
              <div *ngIf="showPackingUnitFilter()" class="dx-field">
                <div id="UnitFilter" class="dx-field-label">{{ 'Einheit' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#UnitFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'UnitFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-autocomplete [(value)]="selectedValidationItem.packingUnitFilter"
                                   [dataSource]="units"
                                   [minSearchLength]="0"
                                   [showDropDownButton]="true"
                                   valueChangeEvent="change"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-autocomplete>
                </div>
              </div>
              <div *ngIf="showPriceListLiveFilter()" class="dx-field">
                <div id="CurrentPriceListFilter" class="dx-field-label">{{ 'Aktuelle Preisliste' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#CurrentPriceListFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'CurrentPriceListFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-switch [(value)]="selectedValidationItem.priceListLiveFilter"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-switch>
                </div>
              </div>
              <div *ngIf="showPriceTypeFilter()" class="dx-field">
                <div id="PriceTypeFilter" class="dx-field-label">{{ 'Preis-Typ' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#PriceTypeFilter" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'PriceTypeFilterTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-autocomplete [(value)]="selectedValidationItem.priceTypeFilter"
                                   [dataSource]="priceTypes"
                                   [minSearchLength]="0"
                                   [showDropDownButton]="true"
                                   valueChangeEvent="change"
                               [showClearButton]="true"
                               [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                               (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-autocomplete>
                </div>
              </div>
              <div class="dx-field">
                <div id="RuleIsCondition" class="dx-field-label">{{ 'Diese Regel ist eine Bedingung' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#RuleIsCondition" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleIsConditionTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-switch [(value)]="selectedValidationItem.isConditional"
                             [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                             (onValueChanged)="onIsConditionalChanged($event)">
                  </dx-switch>
                </div>
              </div>
              <div *ngIf="!selectedValidationItem.isConditional" class="dx-field">
                <div id="RuleConditions" class="dx-field-label">{{ 'Nur prüfen, wenn erfüllt' | translate }}<i class="dx-icon dx-icon-help dq-help-icon"></i></div>
                <dx-tooltip target="#RuleConditions" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
                  <div *dxTemplate="let data = data; of: 'content'">{{ 'RuleConditionsTooltip' | translate }}</div>
                </dx-tooltip>
                <div class="dx-field-value">
                  <dx-tag-box [dataSource]="selectableConditionalRules"
                              valueExpr="id"
                              displayExpr="printName"
                              [(value)]="selectedValidationItem.conditionalRuleIds"
                              [readOnly]="isReadOnlyForUser(selectedValidationMethod)"
                              (onValueChanged)="saveValidationMethod(selectedValidationMethod, $event)">
                  </dx-tag-box>
                </div>
              </div>
            </div>
          </dx-scroll-view>
        </div>
      </div>      
  </content-column>
  <help-column class="{{modelService.systemService.showHelp ? '' : 'd-none'}}"></help-column>
</fullscreen-page>

<ng-template #saveState>
  <span class="dq-save-state order-1 ms-auto text-secondary" role="status" aria-live="polite">
    <span *ngIf="saving">{{ 'Speichert …' | translate }}</span>
    <span *ngIf="saved && !saving" class="text-success">{{ 'Gespeichert.' | translate }}</span>
    <span *ngIf="saveFailed" class="text-danger">{{ 'Speichern fehlgeschlagen. Die Änderung wird beim nächsten Bearbeiten erneut gespeichert.' | translate }}</span>
  </span>
</ng-template>

<ng-template #readOnlyInfo>
  <div *ngIf="isReadOnlyForUser(selectedValidationMethod)" class="alert alert-info dq-readonly-info" role="status">
    <i class="dx-icon dx-icon-info"></i>
    <span class="flex-fill">{{ 'ValidationMethodReadOnlyInfo' | translate }}</span>
    <dx-button stylingMode="outlined" type="default" icon="copy" text="{{ 'Kopieren' | translate }}"
               (onClick)="showDuplicateValidationMethodPopup()"></dx-button>
  </div>
</ng-template>

<dx-popup [width]="500"
          height="auto"
          (onShown)="focusNewValidationMethodName()"
          [showTitle]="true"
          title="{{ 'Datenqualität-Set erstellen' | translate }}"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          contentTemplate="popupContent"
          [(visible)]="createValidationMethodPopupVisible"
          (onHidden)="resetCreateValidationMethodValidation()">
  <dxi-popup-toolbar-item widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    [options]="{ stylingMode: 'contained', type: 'default', text: 'Erstellen' | translate, onClick: createValidationMethod }">
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'popupContent'">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newValidationMethod.name" [showClearButton]="true" valueChangeEvent="keyup"
                     validationMessageMode="always"
                     (onInitialized)="newValidationMethodNameBox = $event.component"
                     (onEnterKey)="createValidationMethod()">
          <dx-validator [validationGroup]="createValidationMethodGroup">
            <dxi-validation-rule type="required" message="{{ 'Bitte Namen eingeben' | translate }}"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
    <div *ngIf="isAdminUser()" class="dx-field">
      <div class="dx-field-label">{{ 'Global' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="newValidationMethod.isGlobal"></dx-switch>
      </div>
    </div>
  </div>
</dx-popup>
